module.exports = __webpack_public_path__ + "img/shape1.b635c108.png";